"use strict";

exports.__esModule = true;
exports.default = void 0;
var _default = {
  "type": "string",
  "enum": ['kg0', 'kg1', 'kg2', 'kg3'],
  "enumNames": ["KG0: På lang sikt", "KG1: På middels lang sikt", "KG2: På kort sikt", "KG3: Strakstiltak"]
};
exports.default = _default;
module.exports = exports.default;